import React from 'react';
import { withRouter } from 'react-router-dom';
import Tabs from '../../../common/components/Tabs';
import {
  TeamsContainer,
  Competitors,
  Profile,
  PurchaseOrders,
  WorkshopsContainer
} from '../../containers';
import { withNamespaces } from 'react-i18next';


const Dashboard = (props) => {
  const { t } = props;

  const panes = [
    {
      title: t('my:menu.my_teams'),
      path: '/my/teams',
      contents: <TeamsContainer/>
    },
    {
      title: t('my:menu.my_workshops'),
      path: '/my/workshops',
      contents: <WorkshopsContainer/>
    },
    {
      title: t('my:menu.registered_teams'),
      path: '/my/competitors',
      contents: <Competitors/>
    },
    {
      title: t('my:menu.purchase_orders'),
      path: '/my/pos',
      contents: <PurchaseOrders/>
    },
    {
      title: t('my:menu.profile'),
      path: '/my/profile',
      contents: <Profile/>
    },
  ];

  return  <Tabs panes={panes}/>;
};

export default withNamespaces('my')(withRouter(Dashboard));




// WEBPACK FOOTER //
// ./src/private/user/components/Dashboard/index.js